<template>
  <div class="nav-user">
    <div class="user-component">
      <div
        class="user d-flex align-center btn"
        @click="
          if ($route.path != '/creator-info') {
            $router.push('/creator-info');
          }
        "
      >
        <v-avatar
          size="32"
          class="cursor-pointer"
          :class="{ 'elevation-2': !avatar }"
        >
          <v-img
            v-if="isLogin"
            :src="avatar || require(`@/assets/icons/avatar.svg`)"
          />
          <v-icon v-else>mdi-account</v-icon>
        </v-avatar>

        <SizeBox width="10" />
        <div>
          <div class="Medium text-14px">{{ Team.nickname }}</div>
        </div>
      </div>
      <div class="setting">
        <ul>
          <li
            v-for="item in menu"
            :key="item.icon"
            class="btn"
            @click="toUrl(item.link)"
          >
            <div class="avatar" :title="$t(item.text)">
              <v-img
                class="icon"
                :src="require(`@/assets/icons/${item.icon}.svg`)"
                width="16"
              />
            </div>
            <div class="tool-tip">
              <img
                src="@/assets/images/exhibition/create_theme/tooltip-arrow.svg"
                alt=""
              />
              <label for="">
                {{ $t(item.text) }}
              </label>
            </div>
          </li>
        </ul>
      </div>
      <v-container fluid style="padding: 0; margin-top: -15px">
        <v-row align="center" style="margin: 0">
          <v-col cols="12" style="padding: 0">
            <v-select
              v-model="select"
              :items="items"
              item-text="state"
              item-value="abbr"
              menu-props="auto"
              label="Select"
              return-object
              hide-details
              prepend-icon="mdi-earth"
              single-line
              @change="changeLang"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { logout } from '@/api/users';
export default {
  data() {
    return {
      menu: [
        {
          icon: 'setting',
          text: 'SIDEBAR.NAV.ITEM.ACCOUNT',
          link: '/account-setting'
        },
        {
          icon: 'money',
          text: 'SIDEBAR.NAV.ITEM.TRANSACTION',
          link: '/buy-history'
        },
        {
          icon: 'house',
          text: 'SIDEBAR.NAV.ITEM.HOMEPAGE',
          link: '/'
        },
        {
          icon: 'logout',
          text: 'SIDEBAR.NAV.ITEM.SIGN_OUT',
          link: '/logout'
        }
      ],
      select: { state: '中文', abbr: 'TW' },
      items: [
        { state: '中文', abbr: 'TW' },
        { state: 'English', abbr: 'EN' }
      ]
    };
  },
  beforeMount() {
    const lang = localStorage.getItem('language') || 'TW';
    this.items.forEach((item) => {
      if (lang == item.abbr) this.select = item;
    });
  },
  methods: {
    async toUrl(link) {
      if (link == '/logout') {
        try {
          await logout(this.$api);
          this.$router.push({name:'exhibitions'})
          this.$store.dispatch('auth/DO_LOGOUT');
        } catch (error) {
          console.log(error);
        }
      }
      else if (link == '/') window.location.href = 'https://virsody.io/';
      else this.$router.push(link);
    },
    changeLang(selected) {
      localStorage.setItem('language', selected.abbr);
      this.$i18n.loadLanguage(selected.abbr);
      this.$emit('reload');
    }
  },
  computed: {
    ...mapGetters({
      logStatus: 'auth/getLogStatus',
      Team: 'auth/getTeam',
      User: 'auth/getUser'
    }),
    isLogin() {
      return this.logStatus === 'login';
    },
    avatar() {
      return this.Team && this.Team.avatar && this.Team.avatar.url;
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-user {
  width: 200px;
  .user-component {
    padding: 0 10px;
  }
  .user {
    margin-bottom: 20px;
  }
  .setting {
    margin-bottom: 20px;
    ul {
      display: flex;
      list-style: none;
      padding: 0;
      justify-content: space-between;
      li {
        font-size: 12px;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        a {
          color: #fff;
        }
        ::v-deep .v-responsive {
          flex: 0.5;
        }
        &:hover {
          .avatar {
            background-color: $neutral500;
          }
          .tool-tip {
            display: block;
          }
        }
        .avatar {
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          border-radius: 50px;
          background-color: #232323;
          margin-bottom: 10px;
        }
        .tool-tip {
          position: absolute;
          bottom: 0;
          display: none;
          label {
            background-color: $neutral500;
            display: block;
            position: absolute;
            top: 13px;
            left: 50%;
            margin: 0 auto;
            text-align: center;
            width: auto;
            font-size: 12px;
            padding: 3px 7px;
            border-radius: 2px;
            white-space: nowrap;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
  ::v-deep .v-select__selection,
  ::v-deep .mdi-earth::before,
  ::v-deep .mdi-menu-down::before {
    color: $neutral300;
  }
  .v-input {
    background-color: #232323;
    border-radius: 100px;
    padding: 0;
    padding: 0 15px;
  }
  ::v-deep .mdi-menu-down::before {
    content: '\F0140';
    font-size: 16px;
  }
  ::v-deep .mdi-earth::before {
    font-size: 20px;
  }
  ::v-deep
    .theme--dark.v-text-field
    > .v-input__control
    > .v-input__slot:before,
  ::v-deep
    .theme--dark.v-text-field
    > .v-input__control
    > .v-input__slot:after {
    display: none;
  }
  ::v-deep .v-select__selection--comma {
    font-size: 12px;
  }
}
</style>